import { Link, useNavigate } from '@tanstack/react-router'
import { LogOut } from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'

function getInitials(value: string | undefined): string {
  if (!value) return '?'
  const words = value.split(/[\s@._-]+/).filter(Boolean)
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase()
  return value.slice(0, 2).toUpperCase()
}

/** Bandeau du portail client : logo, email et déconnexion (pas de sidebar ni de lien MCP). */
export function ClientTopBar() {
  const navigate = useNavigate()
  const { user, logout } = useAuth()

  const handleLogout = async () => {
    try {
      await logout()
    } catch (e) {
      console.error('Logout:', e)
    }
    navigate({ to: '/' })
  }

  return (
    <header className="sticky top-0 z-30 border-b border-gray-200/80 bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-4 py-3 sm:px-8">
        <Link to="/projects" aria-label="Accueil Qolaig">
          <img src="/assets/images/logo.png" alt="Qolaig" className="h-8 w-auto" />
        </Link>
        <div className="flex items-center gap-3">
          <span
            className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-light text-xs font-semibold text-brand-dark"
            aria-hidden
          >
            {getInitials(user?.nom || user?.email)}
          </span>
          <span className="hidden max-w-[260px] truncate text-sm text-gray-700 sm:inline" title={user?.email}>
            {user?.email}
          </span>
          <button
            type="button"
            onClick={handleLogout}
            className="inline-flex min-h-[36px] items-center gap-1.5 rounded-lg border border-gray-300 px-3 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 hover:text-gray-900"
          >
            <LogOut className="h-4 w-4" />
            Se déconnecter
          </button>
        </div>
      </div>
    </header>
  )
}
